export const Shadows = {
	default: "0px 2px 2px rgba(0, 0, 0, 0.15)",
	normal: "0px 0px 10px rgba(0, 0, 0, 0.08)",
	highlighted: "0px 4px 15px rgba(0, 0, 0, 0.16)",
}
